export default {
  mode: {
    light: "Clair",
    dark: "Sombre"
  },
  
  guide: {
    title: "Guide de thème"
  },
  
  colors: {
    title: "Couleurs",
    primary500: "Primaire 500",
    primary600: "Primaire 600", 
    primary700: "Primaire 700",
    secondary500: "Secondaire 500",
    success: "Succès",
    warning: "Attention",
    error: "Erreur",
    background: "Arrière-plan",
    surface: "Surface",
    card: "Carte"
  },
  
  typography: {
    title: "Typographie",
    h1: "Titre 1",
    h1Font: "Texte 4xl Serif",
    h2: "Titre 2", 
    h2Font: "Texte 3xl Serif",
    h3: "Titre 3",
    h3Font: "Texte 2xl Serif",
    body: "Corps de texte",
    bodyFont: "Texte base",
    small: "Petit texte",
    smallFont: "Texte sm"
  },
  
  components: {
    title: "Composants",
    
    buttons: {
      title: "Boutons",
      default: "Défaut",
      outline: "Contour",
      secondary: "Secondaire", 
      ghost: "Fantôme",
      danger: "Danger",
      success: "Succès",
      disabled: "Désactivé",
      loading: "Chargement"
    },
    
    form: {
      title: "Éléments de formulaire",
      input: "Champ de saisie",
      select: "Champ de sélection",
      switch: "Interrupteur"
    },
    
    badges: {
      title: "Badges",
      default: "Défaut",
      secondary: "Secondaire",
      success: "Succès",
      warning: "Attention",
      error: "Erreur",
      mint: "Menthe",
      rose: "Rose",
      outline: "Contour"
    },
    
    alerts: {
      title: "Alertes",
      info: {
        title: "Information",
        description: "Ceci est une alerte d'information."
      },
      success: {
        title: "Succès",
        description: "Ceci est une alerte de succès."
      },
      warning: {
        title: "Attention", 
        description: "Ceci est une alerte d'avertissement."
      },
      error: {
        title: "Erreur",
        description: "Ceci est une alerte d'erreur."
      }
    }
  },
  
  code: {
    title: "Exemples de code",
    darkMode: {
      title: "Implémentation du mode sombre",
      example: "className=\"bg-white dark:bg-dark-card text-gray-900 dark:text-white\""
    }
  }
}
